import { FC } from 'react';
import { Box, BoxProps as ChakraBoxProps, Text } from '@chakra-ui/react';
import { formatAmount, formatDollarAmount } from '../../utils';

export interface DonationProgressProps extends ChakraBoxProps {
  goal: number;
  raised: number;
  isTeam?: boolean;
}

export const DonationProgress: FC<DonationProgressProps> = ({
  goal,
  raised,
  isTeam = false,
  ...rest
}) => {
  const fundraisingGoal = formatAmount(goal);
  const amountRaised = formatDollarAmount(raised);

  return (
    <Box flex="1" flexDirection="row" {...rest}>
      <Text fontSize="xs">
        {isTeam ? 'Your team has raised' : `You've raised`}
      </Text>
      <Text fontSize="1.65rem">{amountRaised}</Text>
      <Text fontSize="xs">
        toward your <span>${fundraisingGoal}</span> {isTeam ? 'team' : ''} goal
      </Text>
    </Box>
  );
};
